import { MessageDescriptor } from 'react-intl';
import { ReactComponent as IconArrowLeft } from '@whitelabel/media/icons/small/arrow-left.svg';
import { INavItem } from '@whitelabel/helpers/types';
import { isOnServer } from '@whitelabel/helpers/utils';
import { PaymentsType } from './types';
import claimsPortalMessages from './messages/commonMsg';

export enum EnvTypes {
  DEVELOPMENT = 'development',
  LOCAL = 'local',
  STAGING = 'staging',
  PRODUCTION = 'production',
}

type ClaimTypes =
  | 'TRIP_CANCELLATION_US_NON_MEDICAL'
  | 'TRIP_CANCELLATION_US_MEDICAL'
  | 'TRIP_CANCELLATION_ROW_NON_MEDICAL'
  | 'TRIP_CANCELLATION_ROW_MEDICAL';

export const CP_ROOT = (process.env.VITE_CP_ROOT ||
  process.env.NEXT_PUBLIC_CP_ROOT ||
  process.env.REACT_APP_CP_ROOT) as 'xcover' | 'rentalcover';
export const APPLICATION_ENV = (process.env.VITE_ENV || process.env.NEXT_PUBLIC_ENV) as EnvTypes;

export const FNOL_CP_BACKEND_FLAG = 'fnol-flow-on-claims-portal-backend';

export const PAYOUT_EMAIL_PARAM = 'payoutEmailParam';

export const STATUS_ACTION_REQUIRED = 'ACTION REQUIRED';

export const CLAIM_SUBMISSION_ERROR_STORAGE_KEY = 'claimSubmissionError';

export const CLAIM_CENTRE_STATUS = 'claim-centre-status';

export const buttonLabelMessage: Record<Exclude<PaymentsType, 'refund'>, MessageDescriptor> = {
  payout: claimsPortalMessages.getMyPayment,
  charge: claimsPortalMessages.payExcess,
};

export const DEFAULT_MAX_SIZE = 10240;

export const REVIEW_SECTION_NAME = 'review';
export const DOC_REQUIRED_SECTION_NAME = 'doc_reqs_section';

export const CLAIM_SUBMITTED_STATUS = 'claimSubmittedStatus';

const PARTNER_PATHNAME_REGEX = /amazon|united|mosaic/i;

export const getFnolFlowNavItems = (): INavItem[] => {
  const isFromMosaic = isOnServer ? false : PARTNER_PATHNAME_REGEX.test(window.location.hostname);

  return [
    {
      key: 'saveProgressButton',
      messageKey: 'saveProgressButtonLabel',
      name: 'Back to your claims',
      path: isFromMosaic ? '/make-a-claim' : '/claims',
      icon: IconArrowLeft,
      ...(isFromMosaic && { tag: 'a' as React.ElementType }),
    },
  ];
};

export const PAYMENT_FLOW_NAV_ITEMS: INavItem[] = [
  {
    key: 'claimPaymentButton',
    messageKey: 'claimPaymentButtonLabel',
    name: 'Back to your claim',
    path: '/claims/:claimReference/details',
    icon: IconArrowLeft,
  },
];

export const INCLUSIONS_AND_EXCLUSIONS_PAGES_MAP: Record<string, string> = {
  vueling: 'claim-test-vueling',
  sas: 'claim-test-sas',
  revolut: 'claim-test-revolut',
};

export const CLAIM_COVERAGE_VARIANT_NAMES = ['new-variant', 'default'] as const;
export const FNOL_IMPROVEMENT_VARIANT_NAMES = ['fnol-improvement', 'default'] as const;

export const FNOL_IMPROVEMENT_CLAIM_TYPES: Record<EnvTypes, Record<ClaimTypes, string>> = {
  [EnvTypes.DEVELOPMENT]: {
    TRIP_CANCELLATION_US_NON_MEDICAL: '329d353b-96ab-4788-9f25-57743c22e368',
    TRIP_CANCELLATION_US_MEDICAL: 'ccf0c315-fffd-4c3c-bcce-55fca4c1cab0',
    TRIP_CANCELLATION_ROW_NON_MEDICAL: '3fcf0fb8-e3ac-47f4-9cce-57c9a48eac85',
    TRIP_CANCELLATION_ROW_MEDICAL: '47c0aebd-f98f-4091-9be2-29a15fb8d783',
  },
  [EnvTypes.LOCAL]: {
    TRIP_CANCELLATION_US_NON_MEDICAL: '329d353b-96ab-4788-9f25-57743c22e368',
    TRIP_CANCELLATION_US_MEDICAL: 'ccf0c315-fffd-4c3c-bcce-55fca4c1cab0',
    TRIP_CANCELLATION_ROW_NON_MEDICAL: '3fcf0fb8-e3ac-47f4-9cce-57c9a48eac85',
    TRIP_CANCELLATION_ROW_MEDICAL: '47c0aebd-f98f-4091-9be2-29a15fb8d783',
  },
  [EnvTypes.STAGING]: {
    TRIP_CANCELLATION_US_NON_MEDICAL: '329d353b-96ab-4788-9f25-57743c22e368',
    TRIP_CANCELLATION_US_MEDICAL: 'ccf0c315-fffd-4c3c-bcce-55fca4c1cab0',
    TRIP_CANCELLATION_ROW_NON_MEDICAL: '3fcf0fb8-e3ac-47f4-9cce-57c9a48eac85',
    TRIP_CANCELLATION_ROW_MEDICAL: '47c0aebd-f98f-4091-9be2-29a15fb8d783',
  },
  [EnvTypes.PRODUCTION]: {
    TRIP_CANCELLATION_US_NON_MEDICAL: '7f07a525-b703-47f9-ad43-584d96b9c138',
    TRIP_CANCELLATION_US_MEDICAL: '448ae092-3c3e-4b31-aee6-a9e8787ec581',
    TRIP_CANCELLATION_ROW_NON_MEDICAL: '9aa52054-ed9b-470b-839c-13a914582b6f',
    TRIP_CANCELLATION_ROW_MEDICAL: 'b23a66f8-0f14-4852-9aaf-a5babf5bd483',
  },
};
